import { render, staticRenderFns } from "./kw_list_label.vue?vue&type=template&id=4bd7007f&scoped=true&"
import script from "./kw_list_label.vue?vue&type=script&lang=js&"
export * from "./kw_list_label.vue?vue&type=script&lang=js&"
import style0 from "./kw_list_label.vue?vue&type=style&index=0&id=4bd7007f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7007f",
  null
  
)

component.options.__file = "kw_list_label.vue"
export default component.exports